import { Injectable } from '@angular/core';
import { ACLService } from '@delon/acl';

/**
 * @deprecated
 *
 * 理论上该服务是不需要的，权限验证有专门的ACLService来做
 * 但是目前服务端返回的权限列表是黑名单，与权限验证需要的白名单逻辑相悖，使用起来很别扭，所以该服务用来提供一个简单的封装，从而在使用上与常理相符
 *
 * 权限验证可以使用该服务，也可以直接使用ACLService
 */
@Injectable({
  providedIn: 'root',
})
export class AuthorityService {
  constructor(private acl: ACLService) {}

  hasReadPermission(permission: string) {
    return this.acl.canAbility({
      ability: [permission + '.read'],
      except: true,
    });
  }

  hasWritePermission(permission: string) {
    return this.acl.canAbility({
      ability: [permission + '.write'],
      except: true,
    });
  }
}
